import { cva } from '@/styled-system/css';

export const inputChipRootRecipe = cva({
  base: {
    'display': 'inline-flex',
    'alignItems': 'center',
    'verticalAlign': 'top',
    'borderRadius': 'Chip',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color)',
      _focusVisible:
        'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.focus}',
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
    'boxShadowColor': { base: 'Chip.border.selected' },
    'paddingInlineStart': 'Chip.padding.horz',
    'backgroundColor': { base: 'Chip.bg.selected' },

    '&:not(:has([data-c11n-component="InputChip.Close"]))': {
      paddingInlineEnd: 'Chip.padding.horz',
    },

    // Enables the flex child (InputChipLabel) to shrink and truncate
    'minWidth': '0',
  },
  variants: {
    elevated: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      elevated: true,
      disabled: false,
      css: {
        'boxShadow': {
          base: 'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.Chip.elevated.default}',
          _focusVisible:
            'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.focus}',
        },
        '&:has([data-c11n-component="InputChip.Close"]:active)': {
          boxShadow:
            'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.Chip.elevated.pressed}',
        },
      },
    },
  ],
});
